import {AddressModel} from './address.model';

export class FoundModel {
	date: Date;
	hour: string;
	vehicle_co: string;
	is_under_seizure: boolean;
	address: AddressModel;
	founded_abroad: boolean;
	police: boolean;
	cc: boolean;
	vvuu: boolean;
	authority_data: string;
	phone: string;
	found_note: string;
}
